import { useState } from "react";
import DoubleComfirmModal from "./DoubleConfirmModal";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";
function DatasetInfo({ item, onDeleteData }) {
  const [DoubleCheckModalShow, setDoubleCheckModalShow] = useState(false);
  const sampleCount = item.samples?.length || 0;

  return (
    <div className="dataset-info">
      <div className="dataset-info-grid">
        <div className="dataset-info-item">
          <span>{pageText("Type")}</span>
          <strong>{pageText(item.media_type || "unknown")}</strong>
        </div>
        <div className="dataset-info-item">
          <span>{pageText("Samples")}</span>
          <strong>{sampleCount.toLocaleString()}</strong>
        </div>
        <div className="dataset-info-item">
          <span>{pageText("Size")}</span>
          <strong>{item.size || "—"}</strong>
        </div>
      </div>
      <button
        type="button"
        className="org-btn org-btn-danger sample-clear-button"
        onClick={() => setDoubleCheckModalShow(true)}
        disabled={sampleCount === 0}
      >
        {buttonText("Clear Data")}
      </button>
      <DoubleComfirmModal
        show={DoubleCheckModalShow}
        onHide={() => setDoubleCheckModalShow(false)}
        datasetName={item.name}
        onDelete={onDeleteData}
      />
    </div>
  );
}

export default DatasetInfo;
